import { USER_ROLES } from 'admin/users/userUtils';
import { DateTimeInput, Edit, ReferenceInput, SelectInput, SimpleForm, TextInput } from 'react-admin';

import { USER_INVITATION_STATUS_CHOICES } from './userInvitationUtils';

export const UserInvitationEdit: React.FC = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <ReferenceInput disabled={true} label="Pozývatel" reference="User" source="inviter.id" sx={{ width: '40em' }}>
        <TextInput disabled={true} source="inviter.email" sx={{ width: '40em' }} />
      </ReferenceInput>
      <TextInput disabled={true} label="E-mail" source="email" sx={{ width: '40em' }} />
      <SelectInput choices={USER_ROLES} disabled={true} label="Rola" source="role" sx={{ width: '40em' }} />
      <DateTimeInput disabled={true} label="Dátum vytvorenia" source="creationTimestamp" />
      <DateTimeInput disabled={true} label="Dátum ekspirácie" source="expirationTimestamp" />
      <SelectInput choices={USER_INVITATION_STATUS_CHOICES} label="Status" source="status" />
    </SimpleForm>
  </Edit>
);
